import { ChatBubbleOvalLeftIcon } from "@heroicons/react/24/outline";
import { DateTime } from "luxon";

interface EmptyConversationStateProps {
  segment?: "teens" | "support";
}

export function EmptyConversationState({
  segment = "teens",
}: EmptyConversationStateProps) {
  if (segment === "support") {
    return <SupportEmptyState />;
  }

  return (
    <div className="flex h-full w-full flex-col items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center space-y-4">
        <div className="rounded-full bg-white p-6 shadow-sm">
          <ChatBubbleOvalLeftIcon className="h-12 w-12 text-gray-400" />
        </div>
        <p className="text-lg text-gray-600">
          Click on a teen to view your conversation
        </p>
      </div>
    </div>
  );
}

function timeOfDayGreeting(hour: number): string {
  if (hour < 12) return "Morning.";
  if (hour < 17) return "Afternoon.";
  return "Evening.";
}

function SupportEmptyState() {
  const now = DateTime.now();

  return (
    <div className="flex h-full w-full items-center justify-center bg-white">
      <div className="w-full max-w-[512px] px-12">
        <p className="text-[11px] uppercase tracking-[1.7px] text-[#c4c0b8]">
          {now.toFormat("cccc, MMMM d")}
        </p>
        <h1 className="font-avantt mt-3 text-5xl font-bold leading-[1.1] tracking-[-1.2px] text-[#1f1e1d]">
          {timeOfDayGreeting(now.hour)}
        </h1>
        <div className="mt-6 h-px w-12 bg-[#e5e2dc]" />
      </div>
    </div>
  );
}
